import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ButtonPrimary from '../components/Buttons/ButtonPrimary';
import MailchimpSignupForm from '../components/LandingPage/MailchimpSignupForm';
import CsrfToken from '../utils/CsrfToken';

const EMAIL_SUPPORT = props?.EMAIL_SUPPORT;

function ButtonSection(props) {
  return (
    <div
      className={`flex w-full justify-center text-center min-[1300px]:justify-start ${
        props.className ?? ''
      }`}
    >
      <ButtonPrimary
        onClick={(event) => (window.location.href = props.url ?? '/')}
        tooltip={props.tooltip}
        id={props.id}
        className={`mt-4 h-10 w-[200px] rounded-3xl rounded-[40px] bg-blue-700 min-[550px]:h-[3.5rem] min-[1300px]:h-[5rem] min-[1300px]:w-[16.875rem] ${
          props.btnClassName ?? ''
        }`}
      >
        <div className="min-[1300px]:start-new-game-text text-sm font-medium uppercase leading-7 tracking-wider text-neutral-100 min-[1300px]:font-semibold">
          {props.text}
        </div>
      </ButtonPrimary>
    </div>
  );
}

function StarNewGameSection() {
  const description =
    'A one-stop destination to create games with friends, ' +
    'organize your own club, meet new people and improve your poker skills';
  const quick_game_url = '/quick-games/create/';

  return (
    <div className="mt-16 flex w-full flex-col items-center justify-center text-center min-[1300px]:mt-[99px]">
      <div className="flex flex-col max-[550px]:w-[90%] min-[1300px]:flex-row ">
        <div className="w-full max-[550px]:mb-[15px] max-[550px]:flex max-[550px]:flex-col max-[550px]:items-center max-[550px]:justify-center">
          <div className="ws-start-new-game-title-sm min-[1300px]:ws-start-new-game-title flex w-[18.5rem] text-neutral-100 min-[550px]:w-[31rem] min-[550px]:text-[32px]  min-[1300px]:w-[31.5rem]  min-[1300px]:text-left">
            Let’s Bring the <br className="hidden min-[1300px]:block" /> Poker Community{' '}
            <br className="hidden min-[1300px]:block" /> Together
          </div>
          <div className="ws-start-new-game-subtitle mt-4 flex hidden w-[24rem] text-left text-white min-[1300px]:block">
            {description}
          </div>
          <form action={`${quick_game_url}`} method="post" className="w-full">
            <CsrfToken />
            <ButtonSection text="Start a Quick Game" className="mt-8 hidden min-[1300px]:block" />
          </form>
        </div>
        <img
          className="h-40 max-[550px]:h-auto min-[550px]:h-[18rem] min-[1300px]:flex min-[1300px]:h-[21.563rem] min-[1300px]:w-[38.875rem]"
          src="/static/images/welcome_screen/community.webp"
          alt="Let’s Bring the Poker Community Together"
        />
      </div>
      <div className="ws-start-new-game-subtitle-sm mt-[24px] block inline-flex h-12 w-64 text-center text-[#F5F5F5]  min-[550px]:w-[24rem] min-[550px]:text-[18px] min-[550px]:leading-[1.3rem] min-[1300px]:hidden">
        {description}
      </div>
      <form action={`${quick_game_url}`} method="post" className="w-full">
        <CsrfToken />
        <ButtonSection
          text="Start a Quick Game"
          url="/cash-games/create"
          className="block min-[550px]:mt-4 min-[1300px]:hidden"
        />
      </form>
    </div>
  );
}

function CustomTournamentSection() {
  const description =
    'Create and customize your own poker tournament, ensure only those with a password or who meet certain requirements can join, and own your own tournament page.';

  return (
    <div className="mt-[25px] flex w-full  flex-col justify-center  text-center min-[550px]:mt-[3rem] min-[1300px]:mt-[115px] ">
      <div className="absolute left-[89%] top-[25%] h-96 w-[10%] rounded-full bg-blue-700 blur-3xl min-[550px]:left-[93%] min-[550px]:top-[50%] min-[550px]:w-[7%] min-[1300px]:hidden " />
      <div className="flex w-full items-center justify-center ">
        <div className="flex h-[32.563rem]  w-[18.375rem] flex-col items-center rounded-2xl  border-0  bg-[#0E42B9] shadow max-[550px]:h-auto max-[550px]:w-[90%] max-[550px]:pb-4 min-[550px]:h-[41rem] min-[550px]:w-[31rem] min-[550px]:items-center min-[1300px]:h-[33.563rem] min-[1300px]:w-[73.375rem] min-[1300px]:flex-row">
          <div className="flex flex-col min-[1300px]:flex-row ">
            <div className="mt-[39px] w-full min-[1300px]:order-2 min-[1300px]:mt-[0px] min-[1300px]:ml-[6.75rem] min-[1300px]:text-left">
              <div className="min-[1300px]:ws-own-mtt-green-title text-sm font-normal uppercase tracking-wider text-teal-400 min-[550px]:text-[18px]">
                Invite your friends
              </div>
              <div className="ws-own-mtt-title-sm min-[1300px]:ws-own-mtt-title text-center text-neutral-100">
                Create Your Own <b className="hidden min-[550px]:block" /> Custom Tournament
              </div>
              <div className="ws-own-mtt-subtitle mt-4 flex hidden h-12 w-[22.375rem] text-left text-[#d6dfed] text-neutral-100 min-[1300px]:block">
                {description}
              </div>
              <ButtonSection
                text="Create Tournament"
                url="/tournament/create"
                className="mt-[7rem] hidden min-[1300px]:block"
              />
            </div>
            <img
              className="ml-[22px] mt-4 flex h-[12.142rem] w-[15.625rem] rounded-[5px] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] max-[550px]:ml-0 max-[550px]:mr-0 max-[550px]:h-auto max-[550px]:w-full max-[550px]:p-3 max-[550px]:shadow-none min-[550px]:h-[18rem] min-[550px]:w-[28rem] min-[1300px]:order-1 min-[1300px]:mt-[0px] min-[1300px]:ml-[32px] min-[1300px]:h-[24.188rem] min-[1300px]:w-[31.125rem]"
              src="/static/images/welcome_screen/custom_mtt.webp"
              alt="Create Your Own Custom Tournament"
            />
          </div>
          <div className="ws-own-mtt-subtitle-sm min-[550px]:ws-description-md mt-4 block flex h-12 w-64 text-center text-neutral-100 text-[#d8deed] min-[550px]:w-[24rem] min-[1300px]:hidden">
            {description}
          </div>
          <ButtonSection
            text="Create Tournament"
            url="/tournament/create"
            className="mt-8 block min-[550px]:mt-16 min-[1300px]:hidden"
          />
        </div>
      </div>
    </div>
  );
}

function OurLobbySection() {
  const description =
    'Check out all the available games created by our own users. Filter based on criteria to join, game type or date';

  return (
    <div className="mt-[3rem] flex w-full flex-col items-center justify-center text-center min-[1300px]:mt-[115px]">
      <div className="absolute left-[-95%] top-[112%] h-96 w-[93%] rounded-full bg-blue-700 blur-3xl min-[550px]:left-[-40%] min-[550px]:top-[150%] min-[550px]:left-[-90%] min-[1024px]:left-[13%] min-[1024px]:left-[9%] min-[1024px]:w-[6%] min-[1024px]:w-[4%] min-[1300px]:hidden " />
      <div className="flex flex-col max-[550px]:w-[90%] min-[1300px]:flex-row">
        <div className="w-full min-[1300px]:w-[37rem] min-[1300px]:text-left">
          <div className="min-[1300px]:ws-own-mtt-green-title text-sm font-normal uppercase tracking-wider text-teal-400 min-[550px]:w-[31rem] min-[550px]:text-[18px]">
            No Account Required
          </div>
          <div className="ws-own-mtt-title-sm min-[1300px]:ws-own-mtt-title w-full text-2xl font-bold capitalize text-neutral-100 min-[550px]:w-[31rem] min-[550px]:text-[32px]">
            Browse our Lobby
          </div>
          <div className="ws-own-mtt-subtitle mt-4 flex hidden h-12 w-[24rem] text-left text-[#c0c3c4] text-neutral-100 min-[1300px]:block">
            {description}
          </div>
          <ButtonSection
            text="Browse Lobby"
            url="/lobby"
            className="mt-20 hidden min-[1300px]:block"
          />
        </div>
        <LazyLoadImage
          className="mt-4 flex h-40 rounded-[5px] border border-[#262842]  shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] max-[550px]:h-auto max-[550px]:border-none max-[550px]:shadow-none min-[550px]:h-[18rem] min-[1300px]:mt-0 min-[1300px]:h-[20.563rem] min-[1300px]:w-[32.875rem]"
          src="/static/images/welcome_screen/ws-our-lobby.webp"
          alt="Browse our Lobby"
        />
      </div>
      <div className="ws-own-mtt-subtitle-sm min-[550px]:ws-description-md mt-[24px] block inline-flex h-12 w-64 text-center text-[#F5F5F5] text-neutral-100 min-[550px]:w-[24rem] min-[1300px]:hidden">
        {description}
      </div>
      <ButtonSection
        text="Browse Lobby"
        url="/lobby"
        className="block min-[550px]:mt-6 min-[1300px]:hidden"
      />
    </div>
  );
}

function OwnPokerClubSection() {
  const description =
    'Create your own club with its own customized club page and URL, set your own membership criteria, and build your own schedule of events. Invite your existing community or start your own!';

  return (
    <div className="mt-[3rem] flex w-full flex-col items-center justify-center text-center min-[1300px]:mt-[115px]">
      <div className="absolute left-[89%] top-[220%] h-96 w-[10%] rounded-full bg-blue-700 blur-3xl min-[550px]:top-[270%] min-[550px]:left-[93%] min-[550px]:w-[7%] min-[1300px]:hidden" />
      <div className="flex flex-col max-[550px]:w-[90%] min-[1300px]:flex-row">
        <div className="w-full min-[1300px]:order-2 min-[1300px]:ml-[96px] min-[1300px]:w-[37rem] min-[1300px]:text-left">
          <div className="min-[1300px]:ws-own-mtt-green-title text-sm font-normal uppercase tracking-wider text-teal-400 min-[550px]:w-[31rem] min-[550px]:text-[18px]">
            Seamless club Creation
          </div>
          <div className="ws-own-mtt-title-sm min-[1300px]:ws-own-mtt-title w-[16rem] text-2xl font-bold capitalize text-neutral-100 max-[550px]:w-full min-[550px]:w-[31rem] min-[550px]:text-[32px]">
            Create Your Own Poker Club
          </div>
          <div className="ws-own-mtt-subtitle mt-4 flex hidden h-12 w-[27rem] text-left text-[#c0c3c4] text-neutral-100 min-[1300px]:block">
            {description}
          </div>
          <ButtonSection
            text="Contact us to inquire"
            url={`mailto:${EMAIL_SUPPORT}?subject=Club%20Creation%20Inquiry`}
            className="mt-20 hidden min-[1300px]:mt-[7rem] min-[1300px]:block"
            btnClassName="!w-[18.9rem]"
          />
        </div>
        <LazyLoadImage
          className="mt-4 flex  h-40 rounded-[5px] border border-[#262842]  shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] max-[550px]:h-auto  max-[550px]:border-none max-[550px]:shadow-none min-[550px]:mt-4 min-[550px]:h-[18rem] min-[1300px]:order-1 min-[1300px]:h-[23.563rem] min-[1300px]:w-[35.875rem] min-[1400px]:ml-[4rem]"
          src="/static/images/welcome_screen/ws-own-club.webp"
          alt="Create Your Own Poker Club"
        />
      </div>
      <div className="ws-own-mtt-subtitle-sm min-[550px]:ws-description-md mt-[24px] block inline-flex h-12 w-64 text-center text-[#F5F5F5] text-neutral-100 min-[550px]:w-[24rem] min-[1300px]:hidden">
        {description}
      </div>
      <ButtonSection
        text="Contact us"
        url={`mailto:${EMAIL_SUPPORT}?subject=Club%20Creation%20Inquiry`}
        className="mt-8 block min-[550px]:mt-16 min-[1300px]:hidden"
      />
    </div>
  );
}

function BuildProfileSection() {
  const description =
    'Set your Avatar, connect your social profiles, build a strong reputation, create your own friend list and choose ' +
    'what information you disclose when joining a new game, tournament or club.';

  return (
    <div className="mt-[25px] mt-[3rem] flex  w-full flex-col justify-center text-center min-[1300px]:mt-[115px] ">
      <div className="flex w-full items-center justify-center ">
        <div className="h-[32.563rem] w-[18.375rem] rounded-2xl border-0 bg-[#0E42B9] shadow max-[550px]:h-auto max-[550px]:w-[90%] max-[550px]:pb-4 min-[550px]:h-[39rem] min-[550px]:w-[31rem] min-[1300px]:h-[33.563rem] min-[1300px]:w-[73.375rem]">
          <div className="flex flex-col min-[1300px]:flex-row ">
            <div className="mt-[39px] w-full  min-[1300px]:mt-[64px] min-[1300px]:ml-[47px] min-[1300px]:w-[47%] min-[1300px]:text-left">
              <div className="  min-[1300px]:ws-own-mtt-green-title text-sm font-normal uppercase tracking-wider text-teal-400 min-[550px]:text-[18px]">
                Select an avatar or use a NFT
              </div>
              <div className="ws-own-mtt-title-sm min-[1300px]:ws-own-mtt-title text-center text-neutral-100 min-[550px]:text-[32px]">
                Build Your Profile
              </div>
              <div className="ws-own-mtt-subtitle mt-4 flex hidden h-12 w-[22.375rem] text-left text-[#c0c3c4] text-neutral-100 min-[1300px]:block">
                {description}
              </div>
              <ButtonSection
                text="Coming Soon"
                url="javascript:void(0);"
                tooltip="Coming Soon"
                id={`tooltip-coming-soon`}
                className="mt-[9rem] hidden min-[1300px]:block "
                btnClassName={'coming-soon-btn !shadow-none'}
              />
            </div>
            <LazyLoadImage
              className="ml-[22px] mt-4 flex h-[12.142rem] w-[15.625rem] rounded-[15px] shadow-[0_4px_4px_0px_rgba(0,0,0,0.25)] max-[550px]:ml-0 max-[550px]:mr-0 max-[550px]:h-auto max-[550px]:w-full max-[550px]:p-3 max-[550px]:shadow-none min-[550px]:h-[18rem] min-[550px]:w-[28rem] min-[1300px]:order-1 min-[1300px]:mt-[64px] min-[1300px]:h-[28.438rem] min-[1300px]:w-[30.938rem]"
              src="/static/images/welcome_screen/ws-build-profile.webp"
              alt="Build Your Profile"
            />
          </div>
          <div className="ws-own-mtt-subtitle-sm min-[550px]:ws-description-md mt-4 block inline-flex h-12 w-64 text-center text-neutral-100 text-[#d8deed] min-[550px]:w-[24rem] min-[1300px]:hidden">
            {description}
          </div>
          <ButtonSection
            text="Coming Soon"
            url="javascript:void(0);"
            tooltip="Coming Soon"
            id={`tooltip-coming`}
            className="mt-8 block min-[550px]:mt-16 min-[1300px]:hidden "
            btnClassName={'coming-soon-btn !shadow-none'}
          />
        </div>
      </div>
    </div>
  );
}

function PanelSetup(props) {
  return (
    <div className="flex w-full justify-center">
      <div
        className={`relative flex h-96 w-72 justify-center max-[550px]:w-[90%] max-[550px]:justify-center min-[550px]:w-[31rem] min-[1300px]:w-[22rem] min-[1400px]:w-[24rem]`}
      >
        <div className="ws-panel-setup absolute left-0 top-[75px] h-72 w-72 rounded-2xl border border-black border-opacity-30  bg-gradient-to-r from-emerald-400 to-blue-700 shadow max-[550px]:w-full min-[550px]:w-full min-[1300px]:top-[85px] min-[1300px]:h-96 min-[1300px]:w-[22rem] min-[1400px]:w-[24rem]" />
        <div className="absolute flex w-full items-center justify-center text-center">
          <div className="absolute left-[72px] top-0 h-36 w-36 rounded-full border-2 border-blue-700 bg-gray-900 max-[550px]:left-auto min-[550px]:left-[150px] min-[600px]:left-[163px] min-[768px]:left-[174px] min-[1300px]:left-[89px] min-[1300px]:h-44 min-[1300px]:w-44 min-[1400px]:left-[102px]">
            <svg
              className="absolute left-[-5px] top-[-5px] block min-[1300px]:hidden"
              xmlns="http://www.w3.org/2000/svg"
              width="150"
              height="150"
              viewBox="0 0 150 150"
              fill="none"
            >
              <circle cx="75" cy="75" r="75" fill="#0E1321" />
              <circle
                cx="75"
                cy="75"
                r="72.5"
                stroke="white"
                strokeOpacity="0.35"
                strokeWidth="5"
              />
            </svg>
            <svg
              className="absolute left-[-2px] top-[-2px] hidden min-[1300px]:block"
              xmlns="http://www.w3.org/2000/svg"
              width="175"
              height="175"
              viewBox="0 0 175 175"
              fill="none"
            >
              <circle cx="87.5" cy="87.5" r="87.5" fill="#0E1321" />
              <circle
                cx="87.5"
                cy="87.5"
                r="85"
                stroke="white"
                strokeOpacity="0.35"
                strokeWidth="5"
              />
            </svg>
          </div>
        </div>
        <div className="absolute top-[209px] h-24 w-64 text-center  leading-[1rem] min-[550px]:top-[198px] min-[550px]:left-[0px] min-[550px]:flex min-[550px]:w-full min-[550px]:w-full min-[550px]:justify-center min-[550px]:leading-normal min-[1300px]:left-[35px] min-[1300px]:top-[230px] min-[1300px]:h-48 min-[1300px]:w-72">
          {props.children}
        </div>
        <div className="absolute left-[20px] top-[161px] h-11 w-64 text-center text-sm font-semibold uppercase leading-none tracking-wider  text-white max-[550px]:left-auto min-[550px]:w-[94%] min-[550px]:text-[18px] min-[1300px]:left-[32px] min-[1300px]:top-[186px] min-[1300px]:h-11 min-[1300px]:w-72">
          {props.title}
        </div>
        <LazyLoadImage
          className="absolute left-[98px] top-[24px] h-24 w-24  max-[550px]:left-auto min-[550px]:left-[175px] min-[600px]:left-[188px] min-[768px]:left-[199px] min-[1300px]:left-[123px] min-[1300px]:top-[28px]  min-[1300px]:h-28 min-[1300px]:w-28  min-[1400px]:left-[136px]"
          src={props.img}
          alt={props.title}
        />
      </div>
    </div>
  );
}

function MakesUsDifferentSection() {
  return (
    <div className="mt-8 flex w-full flex-col  justify-center text-center min-[550px]:mt-[3rem]  min-[1300px]:mt-[115px]">
      <div className="text-[24px] font-bold capitalize  text-white min-[550px]:text-[32px] min-[1300px]:text-5xl">
        What makes us different
      </div>
      <div className=" mt-8 flex flex-col justify-center min-[1300px]:block">
        <div className="flex flex-col  md:gap-3  min-[1300px]:inline-flex min-[1300px]:flex-row">
          <PanelSetup
            title="Simple to Set-Up, Easy to share"
            img="/static/images/welcome_screen/ws-setup.svg"
          >
            <div className="h-24 w-64 text-center  min-[550px]:w-[95%] min-[1300px]:h-48 min-[1300px]:w-[19rem] min-[1300px]:text-justify">
              <span className="text-xs font-normal leading-none text-white  min-[550px]:text-sm min-[1300px]:leading-7">
                Create your poker game, tournament or club in{' '}
              </span>
              <span className="text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-7">
                60 seconds
              </span>
              <span className="text-xs font-normal leading-none text-white min-[550px]:text-sm min-[1300px]:leading-7">
                {' '}
                and easily{' '}
              </span>
              <span className="text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-7">
                share your link
              </span>
              <span className="text-xs font-normal leading-none text-white min-[550px]:text-sm min-[1300px]:leading-7">
                {' '}
                with other players. Players are taken directly to your custom page where they can
                register with{' '}
              </span>
              <span className="text-xs font-normal leading-none text-teal-500 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-7">
                no download required
              </span>
            </div>
          </PanelSetup>

          <PanelSetup
            title="A Fully Customizable Poker Experience"
            img="/static/images/welcome_screen/ws-fully.svg"
          >
            <div className="h-36 w-64 text-center  min-[550px]:w-full min-[1300px]:h-48 min-[1300px]:w-80 min-[1300px]:text-justify">
              <p className="text-xs font-normal leading-none text-white  min-[550px]:text-[18px] min-[550px]:text-sm min-[1300px]:leading-tight">
                Game Structure:{' '}
                <span className="text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-7">
                  Cash, MTT
                </span>
              </p>

              <p className="mt-3 text-xs font-normal leading-none text-white min-[550px]:text-sm  min-[1300px]:leading-tight">
                Games Formats:{' '}
                <span className="text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-tight">
                  NLHE, PLO, Short Deck
                </span>
              </p>

              <p className="mt-3 text-xs font-normal leading-none text-white min-[550px]:text-sm  min-[1300px]:leading-tight">
                Access Restrictions:{' '}
                <span className="text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-tight">
                  free entry, password protection, or token-gating{' '}
                </span>
              </p>

              <p className="mt-3 text-xs font-normal leading-none text-white min-[550px]:text-sm  min-[1300px]:leading-tight">
                Full Control: Upload your own artwork, and table skins and &nbsp;
                <span className="text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-tight">
                  own your custom URL
                </span>
              </p>
            </div>
          </PanelSetup>

          <PanelSetup
            title="Advanced Administrator Tools"
            img="/static/images/welcome_screen/ws-tools.svg"
          >
            <div className="w-64 text-center  min-[550px]:w-full  min-[550px]:px-[4px] min-[1300px]:h-56 min-[1300px]:w-80 min-[1300px]:text-justify">
              <p className="text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-tight">
                Approve/Ban{' '}
                <span className="text-xs font-normal leading-none text-white min-[550px]:text-sm min-[1300px]:leading-tight">
                  {' '}
                  new players or members
                </span>
              </p>

              <p className="mt-3 text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-tight">
                Add administrators{' '}
                <span className="text-xs font-normal leading-none text-white min-[550px]:text-sm min-[1300px]:leading-tight">
                  {' '}
                  for your poker club{' '}
                </span>
              </p>

              <p className="mt-3 text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-tight">
                Access game ledgers,{' '}
                <span className="text-xs font-normal leading-none text-white min-[550px]:text-sm min-[1300px]:leading-tight">
                  hand histories, or game histories across your clubs and games{' '}
                </span>
              </p>

              <p className="mt-3 text-xs font-normal leading-none text-emerald-400 min-[550px]:text-sm min-[1300px]:font-bold min-[1300px]:leading-tight">
                Add a chips for your club,{' '}
                <span className="text-xs font-normal leading-none text-white min-[550px]:text-sm min-[1300px]:leading-tight">
                  {' '}
                  distribute to members, determine buy-in amounts for your club game
                </span>
              </p>
            </div>
          </PanelSetup>
        </div>
      </div>
    </div>
  );
}

function ReadySection() {
  return (
    <div className="mt-[25px] mb-8 flex  w-full flex-col items-center justify-center text-center min-[550px]:mt-[3rem] min-[1300px]:mt-[115px]">
      <div className="flex w-full items-center justify-center ">
        <div className="h-[18.125rem] w-[18.375rem] rounded-2xl border-0 bg-[#0E42B9] shadow max-[550px]:flex max-[550px]:w-[90%] max-[550px]:items-center max-[550px]:p-3 min-[550px]:h-[22rem] min-[550px]:w-[31rem] min-[1300px]:h-[22.875rem] min-[1300px]:w-[73.375rem]">
          <div className="mt-[13px] flex w-full flex-col items-center max-[550px]:mt-0 min-[550px]:mt-[45px] min-[1300px]:mt-[61px]">
            <div className="min-[1300px]:ws-own-mtt-green-title text-sm font-normal uppercase tracking-wider text-teal-400 min-[550px]:text-[18px]">
              Are you ready?
            </div>
            <div className="ws-own-mtt-title-sm  min-[1300px]:ws-own-mtt-title flex w-[16rem] flex-col !text-center  text-neutral-100 max-[550px]:w-full min-[550px]:w-[28rem] min-[550px]:text-[32px] min-[1300px]:w-full">
              Start Your Poker Journey <b className="hidden min-[1300px]:block" /> with us today
            </div>
            <div className="align-center flex flex-col justify-center text-center min-[550px]:mt-6 min-[1300px]:mt-6  min-[1300px]:flex-row  min-[1300px]:gap-2">
              <ButtonPrimary
                onClick={(event) => {
                  window.location.href = '/accounts/signup/';
                }}
                className="mt-4 h-10 w-[200px] !rounded-full rounded-3xl rounded-[40px] !bg-gray-900 uppercase min-[550px]:h-[3.5rem] min-[1300px]:h-20 min-[1300px]:h-[5rem] min-[1300px]:w-96 min-[1300px]:w-[16.875rem]"
                gray="true"
              >
                <div className="text-center text-lg font-medium uppercase leading-7 tracking-widest text-white min-[1300px]:font-semibold">
                  Get started
                </div>
              </ButtonPrimary>

              <ButtonPrimary
                className="mt-4   h-10 w-[200px] !rounded-full rounded-3xl rounded-[40px] bg-blue-700 uppercase min-[550px]:h-[3.5rem] min-[1300px]:h-20 min-[1300px]:h-[5rem] min-[1300px]:w-96 min-[1300px]:w-[16.875rem]"
                onClick={() => {
                  window.location.href = `mailto:${EMAIL_SUPPORT}?subject=Start%20Poker%20Journey`;
                }}
              >
                <div className="text-center text-lg font-medium uppercase leading-7  tracking-widest text-white min-[1300px]:font-semibold">
                  Contact us
                </div>
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div className="ws-footer-bg flex w-full flex-col  items-center  justify-center  text-center min-[1300px]:flex-row min-[1300px]:px-[30px] min-[1400px]:px-[0px] ">
      <div className="mt-6 mb-6 flex flex-col min-[550px]:items-center  min-[1300px]:w-[73.375rem] min-[1300px]:flex-row min-[1300px]:items-baseline ">
        <div className="order-3 mt-6 w-full min-[550px]:w-[60%]  min-[1300px]:order-1 min-[1300px]:mt-0 min-[1300px]:w-full min-[1300px]:text-left">
          <div className=" text-[16px] font-semibold capitalize leading-7 tracking-widest text-neutral-100 min-[1300px]:text-xl">
            Virtue Fo
          </div>
          <div className="px-8 text-[10px]  font-normal leading-none text-stone-400 min-[550px]:px-0 min-[1300px]:text-xs">
            8 The Green, Suite A, Dover 19901 DE USA
            <br />
            <br />
            Virtue Poker is a free to play gaming platform where players can compete to earn real
            prizes. Virtue Gaming is not intended for use for those under 18 years of age.
            <br />
          </div>
        </div>
        <div className="order-2  mt-6 w-full min-[1300px]:mt-0">
          <div className="text-[16px] font-semibold capitalize text-white min-[1300px]:text-xl">
            Join Our Community
          </div>
          <div className="mt-2 flex flex-row justify-center min-[1300px]:mt-8">
            <LazyLoadImage
              onClick={() => window.open('https://twitter.com/Virtue_Poker', '_blank')}
              className="h-11 w-14 cursor-pointer"
              src="/static/images/welcome_screen/ws-twiter.svg"
              alt="twitter icon"
            />
            <LazyLoadImage
              onClick={() => window.open('https://discord.gg/virtuepoker', '_blank')}
              className="h-11 w-14 cursor-pointer"
              src="/static/images/welcome_screen/ws-discord.svg"
              alt="discord icon"
            />
            <LazyLoadImage
              onClick={() => window.open('https://t.me/virtue_poker', '_blank')}
              className="h-11 w-14 cursor-pointer"
              src="/static/images/welcome_screen/ws-telegram.svg"
              alt="telegram icon"
            />
          </div>
        </div>

        <div className="order-1 w-full min-[1300px]:order-3">
          <div className="text-[16px] font-semibold capitalize text-white min-[1300px]:text-xl">
            Sign Up For Our Newsletter
          </div>
          <MailchimpSignupForm
            formClassName={'inline-grid justify-center ml-[-5%]'}
            divClassName={'flex-col'}
            inputClassName={
              'ws-signup-input min-[320px]:w-[230px] min-[370px]:w-[294px] min-[550px]:w-[365px]'
            }
            btnClassName={
              'ws-signup-btn absolute min-[320px]:w-[70px] min-[370px]:w-[89px] min-[550px]:w-[120px] uppercase'
            }
            errorsClassName="!max-w-[18rem] !w-[80%]"
            divBtnClassName={'min-[320px]:ml-[50%] min-[375px]:ml-[51%]'}
          />
        </div>
      </div>
    </div>
  );
}

export default function WelcomeScreenAnonymousUser() {
  return (
    <>
      <div className="anonymous-welcome-screen-bg-mobile min-[550px]:anonymous-welcome-screen-bg min-[1300px]:anonymous-welcome-screen-bg-desktop flex w-full flex-col px-1 text-center min-[550px]:px-14">
        <StarNewGameSection />
        <CustomTournamentSection />
        <OurLobbySection />
        <OwnPokerClubSection />
        <BuildProfileSection />
        <MakesUsDifferentSection />
        <ReadySection />
      </div>
      <Footer />
    </>
  );
}
